export default __webpack_public_path__ + "static/media/image2.25ac2cfc.webp";